import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import * as requests from '../api/requests';

import { addNotification, addErrorNotification } from './notificationsSlice';

const initialState = {};

export const handleChangePassword = createAsyncThunk(
  'changePassword/handleChangePassword',
  async(args, thunkAPI) => {
    const { oldPassword, confirmNewPassword } = args;
    const res = await requests.handleChangePassword(oldPassword, confirmNewPassword);
    const { ok } = res;
    const body = await res.json();

    if (ok) {
      thunkAPI.dispatch(addNotification('Your password has been updated!'));
    } else {
      const errmsg = body.errmsg || 'Something Went Wrong When Changing The Password!';
      thunkAPI.dispatch(addErrorNotification(errmsg));
    }

    return { ok, body };
  }
);

export const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState
});

export default changePasswordSlice.reducer;
